/**
 * Bill Credits actions
 */

import Constants from '../../constants';

const { BillCredit, BillCredits } = Constants;

/**
 * Action object dispatched to get BillCredits
 *
 * @param {string} userId the user id
 * @param {object} params query params
 */
const getBillCredits = (userId, params) => ({
  type: BillCredits.GET_BILL_CREDITS,
  userId,
  params,
});

/**
 * Action object dispatched when fetching bill credits errors
 *
 * @param {object} error error object
 */
const getBillCreditsError = (error) => ({
  type: BillCredits.GET_BILL_CREDITS_ERROR,
  error,
});

/**
 * Action object dispatched when fetching bill credits succeeds
 *
 *  @param {object} action:
 *  {
 *    @property {string} count: total count of bill credits that match the request query
 *    @property {object} billCredits: all fetched bill credits
 *  }
 */
const getBillCreditsSuccess = ({ count, billCredits }) => ({
  type: BillCredits.GET_BILL_CREDITS_SUCCESS,
  count,
  billCredits,
});

/**
 * Action object dispatched to get bill credits export
 *
 * @param {string} userId the user id
 */
const getBillCreditsExport = (userId) => ({
  type: BillCredits.GET_BILL_CREDITS_EXPORT,
  userId,
});

/**
 * Action object dispatched when fetching bill credits export errors
 *
 * @param {object} error error object
 */
const getBillCreditsExportError = (error) => ({
  type: BillCredits.GET_BILL_CREDITS_EXPORT_ERROR,
  error,
});

/**
 * Action object dispatched when fetching bill credits export succeeds
 *
 *  @param {object} action:
 *  {
 *    @property {object} billCredi=ts: all fetched bill credits
 *  }
 */
const getBillCreditsExportSuccess = (billCredits) => ({
  type: BillCredits.GET_BILL_CREDITS_EXPORT_SUCCESS,
  billCredits,
});

/**
 * Action object dispatched to get BillCredits
 *
 * @param {string} userId the user id
 * @param {object} billCreditId the bill credit ID
 */
const getBillCredit = (userId, billCreditId) => ({
  type: BillCredit.GET_BILL_CREDIT,
  userId,
  billCreditId,
});

/**
 * Action object dispatched when fetching bill credits errors
 *
 * @param {object} error error object
 */
const getBillCreditError = (error) => ({
  type: BillCredit.GET_BILL_CREDIT_ERROR,
  error,
});

/**
 * Action object dispatched when fetching bill credits succeeds
 *
 *  @param {object} action:
 *  {
 *    @property {string} count: total count of bill credits that match the request query
 *    @property {object} billCredits: all fetched bill credits
 *  }
 */
const getBillCreditSuccess = ({ billCredit }) => ({
  type: BillCredit.GET_BILL_CREDIT_SUCCESS,
  billCredit,
});

export default {
  getBillCredits,
  getBillCreditsError,
  getBillCreditsSuccess,
  getBillCreditsExport,
  getBillCreditsExportError,
  getBillCreditsExportSuccess,
  getBillCredit,
  getBillCreditError,
  getBillCreditSuccess,
};
